export default __webpack_public_path__ + "static/media/competition-organizers.e7cbccdc.md";